@if (form) {
  <form [formGroup]="form">
    @if (loaded) {
      <se-fe-form-field
    [seFeDataConfig]="{
      label: seFeDataLabel,
      required: isRequired,
      errorMessages: errorMessages}">
        <se-fe-datepicker class="dob-datepicker"
          [formControlName]="ngControl.name"
          [seFeDataSuffix]="age"
          [seFeDataExcludeDates]="datepickerLimit"
          [seFeDataYearRange]="{ future: 0, past: 100 }"
          seFeDataSuffixSize=3
          [seFeDataComfy]="true">
        </se-fe-datepicker>
        @if (control['helpText']) {
          <div seFeHelp>
            {{ control['helpText'] }}
          </div>
        }
      </se-fe-form-field>
    }
  </form>
}
